DJ.addBehavior('js-thematic-slider', '.js-thematic-slider', {
  attach: function(context, settings, behavior) {
    if (window.innerWidth > 974) {
      jQuery('.js-thematic-slider').owlCarousel({
        margin:18,
        items:4,
        loop:false,
        nav: true,
        dots: false,
        autoWidth:true,
      })
    }

    function reportWindowSize() {
      if (window.innerWidth < 974) {
        jQuery('.js-thematic-slider').owlCarousel('destroy');
        window.removeEventListener("resize", reportWindowSize);
      }
    }
    window.addEventListener("resize", reportWindowSize);
  },

  detach: function(context, settings) {}
});
